import axios from 'axios';

const baseUrl = process.env.REACT_APP_GITO_API_URL + "/discounts";


export async function getAllDiscounts(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Discount/get-all-discounts`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch discounts');
    }
}

export async function getDiscount(discountPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Discount/get-discount/${discountPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch discounts');
    }
}

export async function getDiscountsForCustomer(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Discount/get-discounts-for-customer/${customerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch discounts for customer');
    }
}

export async function postCreateDiscount(discountData, apiAccessToken) {
    /*
    {
        "name": "string",
        "description": "string",
        "discountValue": 0,
        "minKwh": 0,
        "maxKwh": 0,
        "startDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "endDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "isCalculatedPerChargingSite": true,
        "discountConditionType": "string",
        "discountValueType": "string"
    }
  */

    try {
        const response = await axios.post(`${baseUrl}/Discount/create-discount`, discountData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create discount');
    }
}

export async function updateDiscount(discountData, apiAccessToken) {
    /*
    {
        "name": "string",
        "description": "string",
        "discountValue": 0,
        "minKwh": 0,
        "maxKwh": 0,
        "startDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "endDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "isCalculatedPerChargingSite": true,
        "discountConditionType": "string",
        "discountValueType": "string"
    }
  */

    try {
        const response = await axios.put(`${baseUrl}/Discount/update-discount`, discountData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create discount');
    }
}

export async function postAssignDiscountToCustomer(discountPublicId, customerPublicId, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/Discount/assign-discount-to-customer/${discountPublicId}/${customerPublicId}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to assign discount to customers');
    }
}

export async function postRemoveDiscountToCustomer(discountPublicId, customerPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/Discount/remove-discount-from-customer/${discountPublicId}/${customerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to assign discount to customers');
    }
}

export async function deleteDiscount(discountPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/Discount/delete-discount/${discountPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete discount');
    }
}